import React, { useEffect, useRef, useState } from "react";
import styles from "./ChatBox.module.css";
import CloseIcon from "@mui/icons-material/Close";
import { askAI } from "./chatAPI";

const ChatBox = ({ onClose }) => {
  const [messages, setMessages] = useState([
    { role: "ai", content: "Hi! How can I help you today?" },
  ]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const endOfMessagesRef = useRef(null);

  const scrollToBottom = () => {
    endOfMessagesRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages, loading]);

  const sendMessage = async () => {
    if (!input.trim()) return;
    const userMessage = { role: "user", content: input };
    setMessages([...messages, userMessage]);
    setInput("");
    setLoading(true);

    const aiReply = await askAI(input);
    setMessages((prev) => [
      ...prev,
      { role: "ai", content: aiReply || "Sorry, something went wrong." },
    ]);
    setLoading(false);
  };

  return (
    <div className={styles.chatBox}>
      <div className={styles.header}>
        <span>{`AI Assistant (Contact : +91 7728832721)`}</span>
        <CloseIcon onClick={onClose} className={styles.closeBtn} />
      </div>
      <div className={styles.body}>
        {messages.map((msg, i) => (
          <div
            key={i}
            className={msg.role === "user" ? styles.userMsg : styles.aiMsg}
          >
            {msg.content}
          </div>
        ))}
        {loading && (
          <div className={`${styles.aiMsg} ${styles.typingDots}`}>
            <span className={styles.dot}></span>
            <span className={styles.dot}></span>
            <span className={styles.dot}></span>
          </div>
        )}
        <div ref={endOfMessagesRef} />
      </div>
      <div className={styles.footer}>
        <input
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && sendMessage()}
          placeholder="Ask me anything..."
        />
        <button onClick={sendMessage}>Send</button>
      </div>
    </div>
  );
};

export default ChatBox;
